module.exports = __webpack_public_path__ + "static/media/score_aLOSE.a4e91ab4.png";